module.exports = __webpack_public_path__ + "static/img/manual-15.170171e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/en/manual-15.png
// module id = QAjA
// module chunks = 4